import { render, staticRenderFns } from "./AppObjectHeader.vue?vue&type=template&id=56148430&scoped=true&"
import script from "./AppObjectHeader.vue?vue&type=script&lang=js&"
export * from "./AppObjectHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppObjectHeader.vue?vue&type=style&index=0&id=56148430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56148430",
  null
  
)

export default component.exports